import clsx from "clsx";
import { Label } from "components";
import { TextareaHTMLAttributes } from "react";
import "./styles.scss";

type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
	label: string;
	error?: string | Array<string>;
	className?: string;
	touched?: boolean;
	Icon?: JSX.Element;
	maxLength?: number;
	value: string;
};

export default function TextAreaInput({
	label,
	placeholder,
	name,
	value,
	required,
	disabled,
	error,
	touched,
	onChange,
	onBlur,
	Icon,
	className = "",
	maxLength
}: TextAreaProps) {
	return (
		<div
			className={clsx(`text-area--wrapper ${className}`, {
				disabled,
				error: error && touched
			})}
		>
			<Label isRequired={!!required}>{label}</Label>
			<div className="input-component">
				<textarea
					name={name}
					value={value}
					placeholder={placeholder}
					onChange={onChange}
					onBlur={onBlur}
					disabled={disabled}
					className=""
					required={required}
					maxLength={maxLength}
				/>
				{Icon}
			</div>
			{error && touched && (
				<div className="white-space--pre-line mt-1 my-0 error-text">
					{Array.isArray(error) ? error.join("\n") : error}
				</div>
			)}
			{maxLength && (
				<div className="flex flex-row justify-end my-2">
					<p className="text-xs">
						{value.length} /{maxLength}
					</p>
				</div>
			)}
		</div>
	);
}
